import React from 'react';
import { View, ScrollView, Image, StyleSheet } from 'react-native';
import {
  RECEIVED_MESSAGES_FETCH_SUCCESS,
  RECEIVED_MESSAGES_FETCH_ERROR,
  SENT_MESSAGES_FETCH_SUCCESS,
  SENT_MESSAGES_FETCH_ERROR,
} from '../../actions/types';
import CustomText from '../../components/customText/CustomText';
import ProfileHeader from '../../components/profileHeader';
import theme from '../../constants/theme.style.js';
import StatsContainer from '../../components/statsContainer/StatsContainer';
import { baseUrl } from '../../constants/baseUrl';

const iconActive = require('../../assets/icons/navigation/profile-active.png');
const icon = require('../../assets/icons/navigation/profile.png');
const letterOutgoing = require('../../assets/icons/letter-outgoing.png');
const letter = require('../../assets/icons/letter.png');

const styles = StyleSheet.create({
  icon: {
    width: theme.ICON_WIDTH,
    height: theme.ICON_WIDTH,
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: theme.GREEN_DARKER_COLOR,
  },
  body: {
    flex: 1,
    backgroundColor: theme.WHITE_COLOR,
    borderTopLeftRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    borderTopRightRadius: theme.BUTTON_BIG_BORDER_RADIUS,
    padding: theme.CONTAINER_MARGIN,
    paddingTop: 20,
  },
  centerWrap: {
    maxWidth: 900,
    width: '100%',
    alignSelf: 'center',
  },
  bodyHeader: {
    fontSize: theme.FONT_SIZE_TITLE,
    fontWeight: theme.FONT_WEIGHT_HEAVY,
    color: theme.GREY_DARKER_COLOR,
    marginTop: 30,
    fontFamily: 'Nunito_ExtraBold',
  },
  link: {
    color: theme.PRIMARY_COLOR,
    fontWeight: 'bold',
    paddingTop: 5,
    textDecorationLine: 'underline',
  },
  fillerView: {
    height: 150,
  },
});

export default class Profile extends React.Component {
  static navigationOptions = {
    title: 'Profile',
    tabBarIcon: ({ focused }) => {
      const iconimg = focused ? iconActive : icon;
      return <Image source={iconimg} style={styles.icon} />;
    },
  };

  constructor(props) {
    const { receivedMessages, sentMessages, currentUser } = props;
    super(props);

    const currentId = currentUser.user ? currentUser.user.id : undefined;
    receivedMessages(
      `${baseUrl}message/receivedMessages/${currentId}`,
      RECEIVED_MESSAGES_FETCH_SUCCESS,
      RECEIVED_MESSAGES_FETCH_ERROR,
    );
    sentMessages(
      `${baseUrl}message/sentMessages/${currentId}`,
      SENT_MESSAGES_FETCH_SUCCESS,
      SENT_MESSAGES_FETCH_ERROR,
    );
  }

  render() {
    const { currentUser, navigation } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.centerWrap}>
          <ProfileHeader ownProfile nav={navigation} />
        </View>
        <ScrollView style={styles.body}>
          <View style={styles.centerWrap}>
            <CustomText style={styles.bodyHeader}>Your Statistics</CustomText>
            <StatsContainer
              image={letter}
              headline="Received Turtlets"
              subheader="from your friends"
              amount={currentUser.receivedMessageCount}
            />
            <StatsContainer
              image={letterOutgoing}
              headline="Sent Turtlets"
              subheader="to your friends"
              amount={currentUser.sentMessageCount}
            />
            <View style={styles.fillerView} />
          </View>
        </ScrollView>
      </View>
    );
  }
}
